import { createReducer } from '@reduxjs/toolkit'

import {
    CAMPAIGN_NAME,
    DATES,
    CAMPAIGN_BUDGET,
    CAMPAIGN_STATES,
    CAMPAIGN_TARGETING_TYPES,
    AGGREGATION,
    FACT_TYPES,
    LABELS,
    METRIC_FILTERS,
} from 'const/filters'
import { FILTER_SETTINGS, FILTERS } from 'const/reducerKeys'

import {
    defaultResourcePageTabs,
    defaultResourcePageWidgets,
    defaultResourcePage,
} from '../defaults'

const defaultState = {
    [FILTERS]: {
        [CAMPAIGN_NAME]: null,
        [FACT_TYPES]: [],
        [CAMPAIGN_BUDGET]: [],
        [CAMPAIGN_STATES]: [],
        [CAMPAIGN_TARGETING_TYPES]: [],
        [LABELS]: [],
        [METRIC_FILTERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [CAMPAIGN_NAME, DATES, AGGREGATION, FACT_TYPES],
        order: [
            CAMPAIGN_STATES,
            CAMPAIGN_BUDGET,
            CAMPAIGN_TARGETING_TYPES,
            LABELS,
            METRIC_FILTERS,
        ],
        displayState: {},
    },

    ...defaultResourcePage,
    tabs: defaultResourcePageTabs,
    widgets: defaultResourcePageWidgets('adAccountPage'),
}

export default createReducer(defaultState, () => {})
